import {CMSContentType} from "./CMSType";
let id = 0;

export interface IJSON {
  toJSON(): any;
}

export interface AContentParams {
  type: CMSContentType;
}

export interface AContentDTO {
  type: string;
}

export abstract class AContent implements IJSON {
  protected _id: number;
  readonly type: CMSContentType;

  constructor(type: CMSContentType) {
    this._id = id++;
    this.type = type;
  }

  protected _merge(data: any): this {
    let newInstance = Object.create(this);
    return Object.assign(newInstance, this, data) as this;
  }

  protected _prepareForMerge() {
    return {type: this.type};
  }

  public includes(t: any) {
    return false;
  }

  public equals(value: AContent): boolean {
    return this._id === value._id;
  }

  public toJSON() {
    return {
      type: this.type
    };
  }
}

export default AContent;



// WEBPACK FOOTER //
// ./src/api/club-cms/base.content.ts